export default function CalendarCellTime(props) {
    return <div className='calendar__cell--time'>{props.hour}</div>;
}
